import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { NgxMaskDirective } from 'ngx-mask';
import { User } from 'src/app/model/User';
import { UserService } from '../../services/user/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-user-account-settings',
    imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgxMaskDirective
],
    templateUrl: './user-account-settings.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./user-account-settings.component.scss']
})
export class UserAccountSettingsComponent implements OnInit {
  @Input() userData!: User;

  firstName = '';
  lastName = '';
  phoneNumber = '';
  requiredFieldMsg = 'This field is required';

  constructor(
    private userService: UserService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    if (this.userData) {
      this.firstName = this.userData.firstName;
      this.lastName = this.userData.lastName;
      this.phoneNumber = this.userData.phoneNumber;
    }
  }

  saveChanges(): void {
    this.userService.updateUserInfo(this.firstName, this.lastName, this.phoneNumber)
      .subscribe({
        next: (updatedUser: User) => {
      // overwrite only the companies on the real User instance:
      updatedUser.companies = this.userData!.companies;
      // now pass that full User back into your stream
      this.userService.updateLocalUser(updatedUser);        },
        error: (error: any) => {
          //this.toastr.error('Failed to update user info.', 'Error');
          console.error('Error updating user info:', error);
        }
      });
  }
}
